export default "__VITE_ASSET__PouAyxfi__"